import type { ViewContainerRef } from '@angular/core'
import { inject, Injectable } from '@angular/core'

import { SiteNavService } from './site-nav.service'
import { AnnouncementService } from '../overlays/announcement/announcement.service'

@Injectable({
  providedIn: 'root',
})
export class OverlaysService {
  private readonly announcementService = inject(AnnouncementService)
  private readonly siteNavService = inject(SiteNavService)

  init(rootRef: ViewContainerRef, contentRef: ViewContainerRef): void {
    this.siteNavService.init(rootRef)
    this.announcementService.init(contentRef)
  }
}
